export default __webpack_public_path__ + "static/media/PROCESS_STEP2_XS.26d64f9a.png";